export default __webpack_public_path__ + "static/media/WG POSTER-01.7327f061.jpg";